<app-editor
  [value]="control().value ?? ''"
  [disabled]="!control().enabled"
  [placeholder]="placeholder() | translate"
  (valueChanged)="onChange($event)"></app-editor>
